<template>
  <div>
    <a-modal v-drag-modal wrap-class-name="custom-modal-wrap" v-model="localVisible" :width="560" :confirmLoading="loading"
      :maskClosable="false" @cancel="cancel" @ok="confirm" :style="{ maxHeight: '80vh', overflow: 'auto' }">
      <div slot="title">{{ innerForm.id ? '编辑角色' : '新增角色' }}</div>
      <div class="modal-content">
        <a-form-model ref="form" :model="innerForm" :rules="rules" :label-col="{ span: 4 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="innerForm.name" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-input v-model="innerForm.remark" allowClear />
          </a-form-model-item>

          <a-checkbox-group v-model="innerForm.permissions">
            <a-descriptions size="small" title="权限" bordered>
              <a-descriptions-item v-for="permissionTypeItem in permissionItems" :key="permissionTypeItem.id" :span="3">
                <div slot="label" style="width: 90px">
                  <a-checkbox :checked="isParentChecked(permissionTypeItem)"
                    :indeterminate="isParentIndeterminate(permissionTypeItem)"
                    @change="(e) => onParentToggle(permissionTypeItem, e.target.checked)">
                    {{ permissionTypeItem.name }}
                  </a-checkbox>
                </div>
                <a-row>
                  <a-col v-for="item in permissionTypeItem.permission_items" :key="item.id" :span="8">
                    <a-checkbox :value="item.id">{{ item.name }}</a-checkbox>
                  </a-col>
                </a-row>
              </a-descriptions-item>
            </a-descriptions>
          </a-checkbox-group>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { roleCreate, roleUpdate } from '@/api/account'
import rules from './rules.js'

export default {
  name: 'FormModal',
  model: { prop: 'visible', event: 'cancel' },
  props: {
    visible: { type: Boolean, default: false },
    form: { type: Object, default: () => ({}) },
    permissionItems: { type: Array, default: () => [] },
  },
  data() {
    return {
      rules,
      loading: false,
      localVisible: this.visible,
      innerForm: this.cloneForm(this.form),
    };
  },
  watch: {
    visible(v) {
      this.localVisible = v;
      if (v) this.innerForm = this.cloneForm(this.form);
    },
    form(v) {
      this.innerForm = this.cloneForm(v);
    },
  },
  methods: {
    cloneForm(src) {
      const copy = JSON.parse(JSON.stringify(src || {}));
      if (!Array.isArray(copy.permissions)) copy.permissions = [];
      copy.permissions = copy.permissions.filter(v => typeof v === 'number');
      return copy;
    },
    isParentChecked(group) {
      const items = group.permission_items || [];
      if (items.length === 0) return false;
      return items.every(it => this.innerForm.permissions.includes(it.id));
    },
    isParentIndeterminate(group) {
      const items = group.permission_items || [];
      const checked = items.filter(it => this.innerForm.permissions.includes(it.id)).length;
      return checked > 0 && checked < items.length;
    },
    onParentToggle(group, checked) {
      const items = group.permission_items || [];
      const set = new Set(this.innerForm.permissions);
      for (const it of items) {
        if (checked) set.add(it.id);
        else set.delete(it.id);
      }
      this.innerForm.permissions = Array.from(set);
    },
    confirm() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.loading = true;
        const payload = {
          ...this.innerForm,
          permissions: this.innerForm.permissions.filter(v => typeof v === 'number'),
        };
        const func = payload.id ? roleUpdate : roleCreate;
        func(payload).then(data => {
          this.$message.success(payload.id ? '修改成功' : '新增成功');
          this.$emit(payload.id ? 'update' : 'create', data);
          this.cancel();
        }).finally(() => {
          this.loading = false;
        });
      });
    },
    cancel() {
      this.$emit('cancel', false);
      if (this.$refs.form) this.$refs.form.resetFields();
    },
  },
}
</script>

<style scoped>
.modal-content {
  max-height: 70vh;
  overflow-y: auto;
}

:deep(.custom-modal-wrap .ant-modal) {
  top: 50px;
  padding-bottom: 50px;
}

:deep(.custom-modal-wrap .ant-modal-body) {
  max-height: calc(80vh - 110px);
  overflow-y: auto;
}
</style>
